import  { useEffect, useState } from "react";

import { AppFooter } from "../../components/main-components/footer";

import { buttonsData } from "../../helpers/mock-data";
import { useLocation, useNavigate } from "react-router-dom";
import classNames from "classnames";

import "../../styles/resources.css";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { useAuth } from "../../services/authentication/authentication.context";
import { AddButton } from "../../components/utilities/buttons";
import { getTutorialsByField } from "../../services/documents/documents.context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { AppAlert } from "../../components/utilities/alert";


export const LessonsPage = () => {

    const chosenField = useLocation().state?.field;

    const { isAuthenticated, userData } = useAuth()

    const [field, setField] = useState(chosenField);
    const [options, setOptions] = useState(false);
    const [alertData, setAlertData] = useState();

    const [tutorials, setTutorials] = useState([]);

    const loadTutorials = async (f) => {
        const res = await getTutorialsByField(f);
        //console.log(res)
        setTutorials(res);
    }

    const navigateTo = useNavigate();

    const cancelOption = () => {
        setField();
        setOptions();
    }

    const getIcon = (field) => {
        return buttonsData.find((data) => data.caption === field)?.icon;
    }

    const openLessonPage = (data) => {
        if (!isAuthenticated) {
            setAlertData({
                caption: "Unuathorized!",
                message: "Please sign in to access this video lesson.",
                acceptAction: () => navigateTo("/login"),
                accept: "OK",
                reject: "Cancel",
                rejectAction: () => setAlertData()
            });
            return;
        }
        navigateTo("/lessonpage",{state:{tutorial: data}})
    }
    

    useEffect(() => {
        loadTutorials(field)
    },[field]);

    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={"Lessons"} background={"/media/resources.jpg"} />
            {alertData && (
                <AppAlert
                    caption={alertData.caption}
                    message={alertData.message}
                    accept={alertData.accept}
                    reject={alertData.reject}
                    acceptAction={alertData.acceptAction}
                    rejectAction={alertData.rejectAction}
                    close={() => setAlertData()}
                />
            )}
            <div>
                <div className="notes-page" style={{flexDirection: "column"}}>
                    {userData?.role === 'admin' && (
                        <div className="adm-btns">
                            <AddButton caption={"Add a new Lesson"} link={"/addlesson"} />
                            <AddButton caption={"Update Lessons"} link={"/updatelesson"} />
                        </div>                 
                    )}
                    <div className="main-page" >
                        <div className="field-caption">
                            Choose field of study
                        </div>
                        <div className="res-buttons">
                            {buttonsData.map((data, k) => (
                                <div className='res-unit'>
                                <button
                                    className={classNames("res-button",`thm-${(k+1)}`)}
                                    onClick={() => {
                                        setField(data.caption);
                                        setOptions(true)
                                    }}
                                    key={k}
                                >
                                    <img src={`/icons/${data.icon}`} className="res-button-icon" alt="" />
                                </button>
                                    <span className="res-button-cap">{data.caption}</span>
                            </div>
                            ))}
                        </div>
                        {(options) && <div className='alert-bg' onClick={() => cancelOption()}/>}
  
                        {tutorials?.length ?
                            <div className={classNames("alert-slider",{'slide-up': options})}>
                                <div className="close-btn-box">
                                    <button className="close-box" onClick={() => cancelOption()}>
                                        <FontAwesomeIcon icon={faClose} className="close-box" />
                                    </button>
                                </div>
                                <div className="field-label">Lessons</div>
                                <div className='option-label'>
                                    <div className="slider-caption">{field}</div>
                                    <img src={`/icons/${getIcon(field)}`} width={32} alt="" />
                                </div>
                            {tutorials?.map((tutorial,indx) => (
                                <div 
                                    className={classNames("vid-prev-unit", `thm-${(indx+1)%9}` )}
                                    key={indx} 
                                    onClick={() => { openLessonPage(tutorial)}}
                                >
                                    <div className="prev-title">{tutorial?.title}</div>
                                </div>
                            ))}
                            </div> :
                                <div className={classNames("alert-slider",{"slide-up": options})}>
                                <div className="close-btn-box">
                                    <button className="close-box" onClick={() => cancelOption()}>
                                        <FontAwesomeIcon icon={faClose} />
                                    </button>
                                </div>
                                <div className="field-label">Lessons</div>
                                    <div className='option-label'>
                                    <div className="slider-caption">{field}</div>
                                    <img src={`/icons/${getIcon(field)}`} width={32}  alt=""/>
                                </div>
                                <div className="field-label">No lesson found in this category</div>
                                </div>
                        }
                               
                            
                        
                    </div>
                </div>
            </div>
           
            <AppFooter />
        </div>
    );
}